import { useQuery } from '@apollo/client/react';
import React from 'react';
import {
  BooleanInput,
  Create,
  required,
  SelectInput,
  SimpleForm,
  TextInput,
} from 'react-admin';
import { AdminGetTrainingPlanFilterOptionsDocument } from '../../graphql/types';
import { attributeToChoice } from './TrainingPlanTemplate';
import {
  transformTrainingPlanTemplate,
  WeekStructureInput,
} from './TrainingPlanWeekStructureInput';

export const TrainingPlanTemplateCreate: React.FC = () => {
  const filterOptions = useQuery(AdminGetTrainingPlanFilterOptionsDocument);
  const {
    trainingPlanTypes = [],
    trainingPlanDifficulties = [],
    trainingPlanDurations = [],
    trainingPlanEquipmentCategories = [],
    trainingPlanFrequencies = [],
    trainingPlanPhases = [],
  } = filterOptions.data || {};

  return (
    <Create transform={transformTrainingPlanTemplate}>
      <SimpleForm>
        <TextInput source="name" fullWidth validate={required()} />
        <BooleanInput source="hidden" defaultValue={true} />
        <SelectInput
          source="type"
          label="Type"
          choices={trainingPlanTypes.map(attributeToChoice)}
        />
        <SelectInput
          source="difficulty"
          choices={trainingPlanDifficulties.map(attributeToChoice)}
          validate={required()}
        />
        <SelectInput
          source="durationMinutes"
          label="Duration (min)"
          choices={trainingPlanDurations.map(attributeToChoice)}
          validate={required()}
        />
        <SelectInput
          source="equipmentCategory"
          label="Equipment Category"
          choices={trainingPlanEquipmentCategories.map(attributeToChoice)}
        />
        <SelectInput
          source="frequency"
          choices={trainingPlanFrequencies.map(attributeToChoice)}
          validate={required()}
        />
        <SelectInput
          source="phase"
          choices={trainingPlanPhases.map(attributeToChoice)}
          validate={required()}
        />
        <WeekStructureInput source="workouts" />
      </SimpleForm>
    </Create>
  );
};
